import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyAllyShopNavPromo = loadable(() => import(/* webpackChunkName: "content/registry/ally-shop-nav-promo" */ './AllyShopNavPromo'), 'AllyShopNavPromo');
